// ============================================================
// 📚 jozveData.js
// داده‌های جزوه‌های کتاب‌خانه + پشتیبانی از جزوه ویژه
// ============================================================
//
// 🔹 ساختار پوشه‌ها روی سرور:
//   پایه ۱-۹:  /media/ketab-jozve/pdf/{پایه}/{نام کتاب}/{فایل}
//   پایه ۱۰-۱۲: /media/ketab-jozve/pdf/{پایه}/{رشته}/{نام کتاب}/{فایل}
//
// 🔹 Lesson (درس) — فیلدهای اختیاری برای جزوه ویژه:
//     {
//       lessonNumber: 1,
//       title: "درس ۱",
//       file: "1.pdf",
//       isPremium: true,           // ← اگر true باشد، جزوه ویژه است
//       coinPrice: 200,            // ← قیمت به سکه (فقط اگر isPremium)
//       description: "...",        // ← توضیح کوتاه (اختیاری)
//       badge: "پرفروش",           // ← بج دلخواه (اختیاری)
//     }
//
// 🔹 اگر isPremium نباشد یا false باشد → جزوه رایگان (مثل قبل)
// 🔹 درس‌های ویژه در ابتدای لیست هر فصل قرار می‌گیرند.
// ============================================================

// مسیر پایه نسبت به ریشه‌ی دامنه
// (اگر اپ زیرمسیر داره، مثلاً /app/، بکن: "/app/media/ketab-jozve/pdf")
export const JOZVE_BASE_PATH = "/media/ketab-jozve/pdf";
export const EXAM_BASE_PATH  = "/media/ketab-exam/pdf";

// ------------------------------------------------------------
// JOZVE_DATA
// ------------------------------------------------------------
// پایه ۱ تا ۹  → { [bookId]: Chapter[] }
// پایه ۱۰ تا ۱۲ → { [fieldId]: { [bookId]: Chapter[] } }
//
// Chapter = { chapterNumber: number, lessons: Lesson[] }
// Lesson  = { lessonNumber: number, title: string, file: string }
// ------------------------------------------------------------

export const JOZVE_DATA = {
  // ==========================================================
  // پایه ۱
  // ==========================================================
  "1": {
  },

  // ==========================================================
  // پایه ۲
  // ==========================================================
  "2": {
  },

  // ==========================================================
  // پایه ۳
  // ==========================================================
  "3": {
  },

  // ==========================================================
  // پایه ۴
  // ==========================================================
  "4": {
  },

  // ==========================================================
  // پایه ۵
  // ==========================================================
  "5": {
  },

  // ==========================================================
  // پایه ۶
  // ==========================================================
  "6": {
  },

  // ==========================================================
  // پایه ۷
  // ==========================================================
  "7": {
    // نمونه — به راحتی کتاب‌های دیگر رو اضافه کن
    // farsi: [...],
    // riazi: [...],
    // olum:  [...],
    // ...
  },

  // ==========================================================
  // پایه ۸
  // ==========================================================
  "8": {},

  // ==========================================================
  // پایه ۹
  // ==========================================================
  "9": {},

  // ==========================================================
  // پایه ۱۰ — ساختار وابسته به رشته
  // ==========================================================
  "10": {
    // هر رشته، یک آبجکت از کتاب‌ها داره
    tajrobi: {
      // riazi:  [ ... ],
      // zist:   [ ... ],
      // shimi:  [ ... ],
      // fizik:  [ ... ],
      // ...
    },
    riazi: {
      // riazi:  [ ... ],
      // ...
    },
    ensani: {
      // ...
    },
  },

  // ==========================================================
  // پایه ۱۱ — ساختار وابسته به رشته
  // ==========================================================
  "11": {
    tajrobi: {},
    riazi: {},
    ensani: {},
  },

  // ==========================================================
  // پایه ۱۲ — ساختار وابسته به رشته
  // ==========================================================
  "12": {
    tajrobi: {},
    riazi: {},
    ensani: {},
  },
};

// 🆕 داده‌ی نمونه سوالات — مستقل از JOZVE_DATA
export const EXAM_DATA = {};

// ============================================================
// Helpers
// ============================================================

/**
 * گرفتن آرایه‌ی فصل‌های یک کتاب
 * @param {Object} params
 * @param {string|number} params.grade
 * @param {string}        params.book   // شناسه‌ی کتاب (= subject id)
 * @param {string}        [params.field] // فقط برای پایه‌های ۱۰-۱۲
 * @returns {Array} آرایه‌ی فصل‌ها
 */
export function getJozveChapters({ grade, book, field, type = 'jozve' }) {
  if (!grade || !book) return [];
  const source = type === 'exam' ? EXAM_DATA : JOZVE_DATA;
  const gradeData = source[String(grade)];
  if (!gradeData) return [];

  if (field) {
    const fieldData = gradeData[field];
    if (!fieldData) return [];
    return fieldData[book] || [];
  }

  // اگر داده‌ی این پایه آرایه نباشه یعنی اشتباهاً رشته لازمه
  const bookData = gradeData[book];
  return Array.isArray(bookData) ? bookData : [];
}

/**
 * ساخت مسیر کامل PDF
 * - اگر `file` از "/" یا "http" شروع بشه، یعنی مسیر/URL دلخواه → مستقیم برگردونده می‌شه
 * - در غیر این صورت: JOZVE_BASE_PATH/grade[/field]/book/file
 * @returns {string}
 */
export function buildJozvePdfUrl({ grade, book, field, file, type = 'jozve' }) {
  if (!file) return "";
  if (file.startsWith("/") || /^https?:\/\//i.test(file)) return file;

  const basePath = type === 'exam' ? EXAM_BASE_PATH : JOZVE_BASE_PATH;
  const parts = [basePath, String(grade)];
  if (field) parts.push(field);
  parts.push(book, file);

  // جلوگیری از // اضافه (به جز ابتدای URL)
  return parts.join("/").replace(/([^:]\/)\/+/g, "$1");
}









// ============================================================
// 🆕 Helpers برای جزوه ویژه
// ============================================================

/** ساخت jozveId یکتا برای هر درس */
export function buildJozveId({ grade, field, book, chapterNumber, lessonNumber, type = 'jozve' }) {
  const baseId = [
    String(grade || ""),
    field || "none",
    book || "",
    String(chapterNumber ?? ""),
    String(lessonNumber ?? ""),
  ].join("-");
  return type === 'exam' ? `exam-${baseId}` : baseId;
}

/** آیا این درس ویژه است؟ */
export function isLessonPremium(lesson) {
  return !!(lesson && lesson.isPremium === true);
}

/** مرتب‌سازی درس‌ها: premium اول، بعد بر اساس شماره */
export function sortLessonsByPremium(lessons) {
  if (!Array.isArray(lessons)) return [];
  return [...lessons].sort((a, b) => {
    const aPrem = isLessonPremium(a) ? 0 : 1;
    const bPrem = isLessonPremium(b) ? 0 : 1;
    if (aPrem !== bPrem) return aPrem - bPrem;
    return (a.lessonNumber || 0) - (b.lessonNumber || 0);
  });
}

/** مرتب‌سازی فصل‌ها: فصلی که premium دارد اول بیاید */
export function sortChaptersByPremium(chapters) {
  if (!Array.isArray(chapters)) return [];
  return [...chapters].sort((a, b) => {
    const aHasPrem = (a.lessons || []).some(isLessonPremium) ? 0 : 1;
    const bHasPrem = (b.lessons || []).some(isLessonPremium) ? 0 : 1;
    if (aHasPrem !== bHasPrem) return aHasPrem - bHasPrem;
    return (a.chapterNumber || 0) - (b.chapterNumber || 0);
  });
}